export const environment = {
  isSentryEnabled: true,
  production: true,
  recaptcha: {
    enable: true,
    siteKeyV2: '6LefhKoqAAAAAGcwHjO5AC8QX_qnVNcKVWEQ0f90',
    siteKeyV3: '6Lf7haoqAAAAAChv58YT52xUsmIigoJO-qJZ5XKt',
  },
};
